export default __webpack_public_path__ + "static/media/skippedmeal_5@2x.1443fc16.jpg";